import { render, staticRenderFns } from "./CountDownV2.vue?vue&type=template&id=3d5d8fd4&scoped=true"
import script from "./CountDownV2.vue?vue&type=script&lang=js"
export * from "./CountDownV2.vue?vue&type=script&lang=js"
import style0 from "./CountDownV2.vue?vue&type=style&index=0&id=3d5d8fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5d8fd4",
  null
  
)

export default component.exports